import { createContext } from 'react';

import { DeviceHealth } from '@totem/components/devices/health/types';

interface Context {
  deviceId: string;
  loading: boolean;
  data: DeviceHealth;
  action: string;
  onAction?: (action: string) => void;
}

export default createContext<Context>({
  deviceId: '',
  loading: false,
  data: null,
  action: '',
  onAction: () => {},
});
